import React, { useState } from 'react';
import { X } from 'lucide-react';
import getMediaUrl from '../../../components/tools/utils.jsx';

const Carousel2 = ({ product }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const productImages = product?.images ?? [];
    const defaultImage = productImages.find((image) => image?.is_default);
    const images = defaultImage
        ? [defaultImage, ...productImages.filter((image) => image?.id !== defaultImage.id)]
        : productImages;

    if (images.length === 0) {
        return (
            <div className="h-full flex flex-col gap-3">
                <div className="flex-1 flex items-center justify-center bg-black/20 dark:bg-black/30 rounded-xl">
                    <p className="text-gray-400 text-sm">Sin imágenes</p>
                </div>
            </div>
        );
    }

    return (
        <div className="h-full flex flex-col gap-3">
            {/* Main image */}
            <div
                className="flex-1 flex items-center justify-center bg-black/20 dark:bg-black/30 rounded-xl overflow-hidden cursor-zoom-in relative min-h-[240px]"
                onClick={() => setIsModalOpen(true)}
            >
                <img
                    src={getMediaUrl(images[currentSlide]?.image)}
                    alt={`Imagen ${currentSlide + 1}`}
                    className="max-h-full max-w-full object-contain p-4"
                />
            </div>

            {/* Thumbnails */}
            {images.length > 1 && (
                <div className="flex gap-2 overflow-x-auto pb-1" style={{ scrollbarWidth: 'none' }}>
                    {images.map((img, i) => (
                        <button
                            key={i}
                            onClick={() => setCurrentSlide(i)}
                            className={`flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden border-2 transition-all duration-200
                                ${i === currentSlide
                                    ? 'border-brand-red shadow-sm shadow-brand-red/30'
                                    : 'border-transparent hover:border-white/40 opacity-70 hover:opacity-100'
                                }`}
                        >
                            <img
                                src={getMediaUrl(img.image)}
                                alt={`Miniatura ${i + 1}`}
                                className="w-full h-full object-cover"
                            />
                        </button>
                    ))}
                </div>
            )}

            {/* Lightbox modal */}
            {isModalOpen && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
                    onClick={() => setIsModalOpen(false)}
                >
                    <button
                        className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors"
                        onClick={() => setIsModalOpen(false)}
                    >
                        <X size={20} />
                    </button>
                    <img
                        src={getMediaUrl(images[currentSlide]?.image)}
                        alt="Imagen completa"
                        className="max-w-full max-h-[90vh] object-contain rounded-xl"
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            )}
        </div>
    );
};

export default Carousel2;
